/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedDriveRouteRouteImport } from './routes/_authenticated/drive/route'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as ShareTokenRouteImport } from './routes/share/$token'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminAuditRouteImport } from './routes/_authenticated/admin/audit'
import { Route as AuthenticatedAdminContentRouteImport } from './routes/_authenticated/admin/content'
import { Route as AuthenticatedAdminEmailRouteImport } from './routes/_authenticated/admin/email'
import { Route as AuthenticatedAdminPoliciesRouteImport } from './routes/_authenticated/admin/policies'
import { Route as AuthenticatedAdminSecurityRouteImport } from './routes/_authenticated/admin/security'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin/settings'
import { Route as AuthenticatedAdminStorageRouteImport } from './routes/_authenticated/admin/storage'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as AuthenticatedDocsIndexRouteImport } from './routes/_authenticated/docs/index'
import { Route as AuthenticatedDocsDocumentIdRouteImport } from './routes/_authenticated/docs/$documentId'
import { Route as AuthenticatedDocsNewRouteImport } from './routes/_authenticated/docs/new'
import { Route as AuthenticatedDocsTemplatesRouteImport } from './routes/_authenticated/docs/templates'
import { Route as AuthenticatedDriveIndexRouteImport } from './routes/_authenticated/drive/index'
import { Route as AuthenticatedDriveRecentRouteImport } from './routes/_authenticated/drive/recent'
import { Route as AuthenticatedDriveSearchRouteImport } from './routes/_authenticated/drive/search'
import { Route as AuthenticatedDriveSharedRouteImport } from './routes/_authenticated/drive/shared'
import { Route as AuthenticatedDriveSpamRouteImport } from './routes/_authenticated/drive/spam'
import { Route as AuthenticatedDriveStarredRouteImport } from './routes/_authenticated/drive/starred'
import { Route as AuthenticatedDriveStorageRouteImport } from './routes/_authenticated/drive/storage'
import { Route as AuthenticatedDriveTrashRouteImport } from './routes/_authenticated/drive/trash'
import { Route as AuthenticatedFormsIndexRouteImport } from './routes/_authenticated/forms/index'
import { Route as AuthenticatedFormsNewRouteImport } from './routes/_authenticated/forms/new'
import { Route as AuthenticatedFormsTemplatesRouteImport } from './routes/_authenticated/forms/templates'
import { Route as AuthenticatedFormsv2IndexRouteImport } from './routes/_authenticated/formsv2/index'
import { Route as AuthenticatedFormsv2FormIdRouteImport } from './routes/_authenticated/formsv2/$formId'
import { Route as AuthenticatedFormsv2NewRouteImport } from './routes/_authenticated/formsv2/new'
import { Route as AuthenticatedFormsv2TemplatesRouteImport } from './routes/_authenticated/formsv2/templates'
import { Route as AuthenticatedFormsv3IndexRouteImport } from './routes/_authenticated/formsv3/index'
import { Route as AuthenticatedSheetsIndexRouteImport } from './routes/_authenticated/sheets/index'
import { Route as AuthenticatedSheetsSpreadsheetIdRouteImport } from './routes/_authenticated/sheets/$spreadsheetId'
import { Route as AuthenticatedSheetsNewRouteImport } from './routes/_authenticated/sheets/new'
import { Route as AuthenticatedSheetsTemplatesRouteImport } from './routes/_authenticated/sheets/templates'
import { Route as FormsFormIdFillRouteImport } from './routes/forms/$formId/fill'
import { Route as Formsv2FFormIdRouteImport } from './routes/formsv2/f/$formId'
import { Route as Formsv3FFormIdRouteImport } from './routes/formsv3/f/$formId'
import { Route as AuthenticatedDriveFileFileIdRouteImport } from './routes/_authenticated/drive/file/$fileId'
import { Route as AuthenticatedDriveFolderFolderIdRouteImport } from './routes/_authenticated/drive/folder/$folderId'
import { Route as AuthenticatedFormsFormIdIndexRouteImport } from './routes/_authenticated/forms/$formId/index'
import { Route as AuthenticatedFormsFormIdEditRouteImport } from './routes/_authenticated/forms/$formId/edit'
import { Route as AuthenticatedFormsFormIdPreviewRouteImport } from './routes/_authenticated/forms/$formId/preview'
import { Route as AuthenticatedFormsFormIdResponsesRouteImport } from './routes/_authenticated/forms/$formId/responses'
import { Route as AuthenticatedFormsv2FormIdIndexRouteImport } from './routes/_authenticated/formsv2/$formId/index'
import { Route as AuthenticatedFormsv2FormIdContentRouteImport } from './routes/_authenticated/formsv2/$formId/content'
import { Route as AuthenticatedFormsv2FormIdDesignRouteImport } from './routes/_authenticated/formsv2/$formId/design'
import { Route as AuthenticatedFormsv2FormIdResultsRouteImport } from './routes/_authenticated/formsv2/$formId/results'
import { Route as AuthenticatedFormsv2FormIdShareRouteImport } from './routes/_authenticated/formsv2/$formId/share'
import { Route as AuthenticatedFormsv2FormIdWorkflowRouteImport } from './routes/_authenticated/formsv2/$formId/workflow'
import { Route as AuthenticatedFormsv2FormIdPreviewRouteImport } from './routes/_authenticated/formsv2/$formId_.preview'
import { Route as AuthenticatedFormsv3FormIdIndexRouteImport } from './routes/_authenticated/formsv3/$formId/index'
import { Route as AuthenticatedFormsv3FormIdSubmissionsRouteImport } from './routes/_authenticated/formsv3/$formId/submissions'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDriveRouteRoute = AuthenticatedDriveRouteRouteImport.update({
  id: '/drive',
  path: '/drive',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminContentRoute =
  AuthenticatedAdminContentRouteImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminEmailRoute = AuthenticatedAdminEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminPoliciesRoute =
  AuthenticatedAdminPoliciesRouteImport.update({
    id: '/policies',
    path: '/policies',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminSecurityRoute =
  AuthenticatedAdminSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminSettingsRoute =
  AuthenticatedAdminSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminStorageRoute =
  AuthenticatedAdminStorageRouteImport.update({
    id: '/storage',
    path: '/storage',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedDocsIndexRoute = AuthenticatedDocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDocsDocumentIdRoute =
  AuthenticatedDocsDocumentIdRouteImport.update({
    id: '/docs/$documentId',
    path: '/docs/$documentId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDocsNewRoute = AuthenticatedDocsNewRouteImport.update({
  id: '/docs/new',
  path: '/docs/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDocsTemplatesRoute =
  AuthenticatedDocsTemplatesRouteImport.update({
    id: '/docs/templates',
    path: '/docs/templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDriveIndexRoute = AuthenticatedDriveIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedDriveRouteRoute,
} as any)
const AuthenticatedDriveRecentRoute =
  AuthenticatedDriveRecentRouteImport.update({
    id: '/recent',
    path: '/recent',
    getParentRoute: () => AuthenticatedDriveRouteRoute,
  } as any)
const AuthenticatedDriveSearchRoute =
  AuthenticatedDriveSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => AuthenticatedDriveRouteRoute,
  } as any)
const AuthenticatedDriveSharedRoute =
  AuthenticatedDriveSharedRouteImport.update({
    id: '/shared',
    path: '/shared',
    getParentRoute: () => AuthenticatedDriveRouteRoute,
  } as any)
const AuthenticatedDriveSpamRoute = AuthenticatedDriveSpamRouteImport.update({
  id: '/spam',
  path: '/spam',
  getParentRoute: () => AuthenticatedDriveRouteRoute,
} as any)
const AuthenticatedDriveStarredRoute =
  AuthenticatedDriveStarredRouteImport.update({
    id: '/starred',
    path: '/starred',
    getParentRoute: () => AuthenticatedDriveRouteRoute,
  } as any)
const AuthenticatedDriveStorageRoute =
  AuthenticatedDriveStorageRouteImport.update({
    id: '/storage',
    path: '/storage',
    getParentRoute: () => AuthenticatedDriveRouteRoute,
  } as any)
const AuthenticatedDriveTrashRoute = AuthenticatedDriveTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AuthenticatedDriveRouteRoute,
} as any)
const AuthenticatedFormsIndexRoute = AuthenticatedFormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedFormsNewRoute = AuthenticatedFormsNewRouteImport.update({
  id: '/forms/new',
  path: '/forms/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedFormsTemplatesRoute =
  AuthenticatedFormsTemplatesRouteImport.update({
    id: '/forms/templates',
    path: '/forms/templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFormsv2IndexRoute =
  AuthenticatedFormsv2IndexRouteImport.update({
    id: '/formsv2/',
    path: '/formsv2/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFormsv2FormIdRoute =
  AuthenticatedFormsv2FormIdRouteImport.update({
    id: '/formsv2/$formId',
    path: '/formsv2/$formId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFormsv2NewRoute = AuthenticatedFormsv2NewRouteImport.update({
  id: '/formsv2/new',
  path: '/formsv2/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedFormsv2TemplatesRoute =
  AuthenticatedFormsv2TemplatesRouteImport.update({
    id: '/formsv2/templates',
    path: '/formsv2/templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFormsv3IndexRoute =
  AuthenticatedFormsv3IndexRouteImport.update({
    id: '/formsv3/',
    path: '/formsv3/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSheetsIndexRoute =
  AuthenticatedSheetsIndexRouteImport.update({
    id: '/sheets/',
    path: '/sheets/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSheetsSpreadsheetIdRoute =
  AuthenticatedSheetsSpreadsheetIdRouteImport.update({
    id: '/sheets/$spreadsheetId',
    path: '/sheets/$spreadsheetId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSheetsNewRoute = AuthenticatedSheetsNewRouteImport.update({
  id: '/sheets/new',
  path: '/sheets/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSheetsTemplatesRoute =
  AuthenticatedSheetsTemplatesRouteImport.update({
    id: '/sheets/templates',
    path: '/sheets/templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const FormsFormIdFillRoute = FormsFormIdFillRouteImport.update({
  id: '/forms/$formId/fill',
  path: '/forms/$formId/fill',
  getParentRoute: () => rootRouteImport,
} as any)
const Formsv2FFormIdRoute = Formsv2FFormIdRouteImport.update({
  id: '/formsv2/f/$formId',
  path: '/formsv2/f/$formId',
  getParentRoute: () => rootRouteImport,
} as any)
const Formsv3FFormIdRoute = Formsv3FFormIdRouteImport.update({
  id: '/formsv3/f/$formId',
  path: '/formsv3/f/$formId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedDriveFileFileIdRoute =
  AuthenticatedDriveFileFileIdRouteImport.update({
    id: '/file/$fileId',
    path: '/file/$fileId',
    getParentRoute: () => AuthenticatedDriveRouteRoute,
  } as any)
const AuthenticatedDriveFolderFolderIdRoute =
  AuthenticatedDriveFolderFolderIdRouteImport.update({
    id: '/folder/$folderId',
    path: '/folder/$folderId',
    getParentRoute: () => AuthenticatedDriveRouteRoute,
  } as any)
const AuthenticatedFormsFormIdIndexRoute =
  AuthenticatedFormsFormIdIndexRouteImport.update({
    id: '/forms/$formId/',
    path: '/forms/$formId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFormsFormIdEditRoute =
  AuthenticatedFormsFormIdEditRouteImport.update({
    id: '/forms/$formId/edit',
    path: '/forms/$formId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFormsFormIdPreviewRoute =
  AuthenticatedFormsFormIdPreviewRouteImport.update({
    id: '/forms/$formId/preview',
    path: '/forms/$formId/preview',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFormsFormIdResponsesRoute =
  AuthenticatedFormsFormIdResponsesRouteImport.update({
    id: '/forms/$formId/responses',
    path: '/forms/$formId/responses',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFormsv2FormIdIndexRoute =
  AuthenticatedFormsv2FormIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedFormsv2FormIdRoute,
  } as any)
const AuthenticatedFormsv2FormIdContentRoute =
  AuthenticatedFormsv2FormIdContentRouteImport.update({
    id: '/content',
    path: '/content',
    getParentRoute: () => AuthenticatedFormsv2FormIdRoute,
  } as any)
const AuthenticatedFormsv2FormIdDesignRoute =
  AuthenticatedFormsv2FormIdDesignRouteImport.update({
    id: '/design',
    path: '/design',
    getParentRoute: () => AuthenticatedFormsv2FormIdRoute,
  } as any)
const AuthenticatedFormsv2FormIdResultsRoute =
  AuthenticatedFormsv2FormIdResultsRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => AuthenticatedFormsv2FormIdRoute,
  } as any)
const AuthenticatedFormsv2FormIdShareRoute =
  AuthenticatedFormsv2FormIdShareRouteImport.update({
    id: '/share',
    path: '/share',
    getParentRoute: () => AuthenticatedFormsv2FormIdRoute,
  } as any)
const AuthenticatedFormsv2FormIdWorkflowRoute =
  AuthenticatedFormsv2FormIdWorkflowRouteImport.update({
    id: '/workflow',
    path: '/workflow',
    getParentRoute: () => AuthenticatedFormsv2FormIdRoute,
  } as any)
const AuthenticatedFormsv2FormIdPreviewRoute =
  AuthenticatedFormsv2FormIdPreviewRouteImport.update({
    id: '/formsv2/$formId_/preview',
    path: '/formsv2/$formId/preview',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFormsv3FormIdIndexRoute =
  AuthenticatedFormsv3FormIdIndexRouteImport.update({
    id: '/formsv3/$formId/',
    path: '/formsv3/$formId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFormsv3FormIdSubmissionsRoute =
  AuthenticatedFormsv3FormIdSubmissionsRouteImport.update({
    id: '/formsv3/$formId/submissions',
    path: '/formsv3/$formId/submissions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/drive': typeof AuthenticatedDriveRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/share/$token': typeof ShareTokenRoute
  '/admin/audit': typeof AuthenticatedAdminAuditRoute
  '/admin/content': typeof AuthenticatedAdminContentRoute
  '/admin/email': typeof AuthenticatedAdminEmailRoute
  '/admin/policies': typeof AuthenticatedAdminPoliciesRoute
  '/admin/security': typeof AuthenticatedAdminSecurityRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/storage': typeof AuthenticatedAdminStorageRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/docs/$documentId': typeof AuthenticatedDocsDocumentIdRoute
  '/docs/new': typeof AuthenticatedDocsNewRoute
  '/docs/templates': typeof AuthenticatedDocsTemplatesRoute
  '/drive/recent': typeof AuthenticatedDriveRecentRoute
  '/drive/search': typeof AuthenticatedDriveSearchRoute
  '/drive/shared': typeof AuthenticatedDriveSharedRoute
  '/drive/spam': typeof AuthenticatedDriveSpamRoute
  '/drive/starred': typeof AuthenticatedDriveStarredRoute
  '/drive/storage': typeof AuthenticatedDriveStorageRoute
  '/drive/trash': typeof AuthenticatedDriveTrashRoute
  '/forms/new': typeof AuthenticatedFormsNewRoute
  '/forms/templates': typeof AuthenticatedFormsTemplatesRoute
  '/formsv2/$formId': typeof AuthenticatedFormsv2FormIdRouteWithChildren
  '/formsv2/new': typeof AuthenticatedFormsv2NewRoute
  '/formsv2/templates': typeof AuthenticatedFormsv2TemplatesRoute
  '/sheets/$spreadsheetId': typeof AuthenticatedSheetsSpreadsheetIdRoute
  '/sheets/new': typeof AuthenticatedSheetsNewRoute
  '/sheets/templates': typeof AuthenticatedSheetsTemplatesRoute
  '/forms/$formId/fill': typeof FormsFormIdFillRoute
  '/formsv2/f/$formId': typeof Formsv2FFormIdRoute
  '/formsv3/f/$formId': typeof Formsv3FFormIdRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/docs/': typeof AuthenticatedDocsIndexRoute
  '/drive/': typeof AuthenticatedDriveIndexRoute
  '/forms/': typeof AuthenticatedFormsIndexRoute
  '/formsv2/': typeof AuthenticatedFormsv2IndexRoute
  '/formsv3/': typeof AuthenticatedFormsv3IndexRoute
  '/sheets/': typeof AuthenticatedSheetsIndexRoute
  '/drive/file/$fileId': typeof AuthenticatedDriveFileFileIdRoute
  '/drive/folder/$folderId': typeof AuthenticatedDriveFolderFolderIdRoute
  '/forms/$formId/edit': typeof AuthenticatedFormsFormIdEditRoute
  '/forms/$formId/preview': typeof AuthenticatedFormsFormIdPreviewRoute
  '/forms/$formId/responses': typeof AuthenticatedFormsFormIdResponsesRoute
  '/formsv2/$formId/content': typeof AuthenticatedFormsv2FormIdContentRoute
  '/formsv2/$formId/design': typeof AuthenticatedFormsv2FormIdDesignRoute
  '/formsv2/$formId/results': typeof AuthenticatedFormsv2FormIdResultsRoute
  '/formsv2/$formId/share': typeof AuthenticatedFormsv2FormIdShareRoute
  '/formsv2/$formId/workflow': typeof AuthenticatedFormsv2FormIdWorkflowRoute
  '/formsv2/$formId/preview': typeof AuthenticatedFormsv2FormIdPreviewRoute
  '/formsv3/$formId/submissions': typeof AuthenticatedFormsv3FormIdSubmissionsRoute
  '/forms/$formId/': typeof AuthenticatedFormsFormIdIndexRoute
  '/formsv2/$formId/': typeof AuthenticatedFormsv2FormIdIndexRoute
  '/formsv3/$formId/': typeof AuthenticatedFormsv3FormIdIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/share/$token': typeof ShareTokenRoute
  '/': typeof AuthenticatedIndexRoute
  '/admin/audit': typeof AuthenticatedAdminAuditRoute
  '/admin/content': typeof AuthenticatedAdminContentRoute
  '/admin/email': typeof AuthenticatedAdminEmailRoute
  '/admin/policies': typeof AuthenticatedAdminPoliciesRoute
  '/admin/security': typeof AuthenticatedAdminSecurityRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/storage': typeof AuthenticatedAdminStorageRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/docs/$documentId': typeof AuthenticatedDocsDocumentIdRoute
  '/docs/new': typeof AuthenticatedDocsNewRoute
  '/docs/templates': typeof AuthenticatedDocsTemplatesRoute
  '/drive/recent': typeof AuthenticatedDriveRecentRoute
  '/drive/search': typeof AuthenticatedDriveSearchRoute
  '/drive/shared': typeof AuthenticatedDriveSharedRoute
  '/drive/spam': typeof AuthenticatedDriveSpamRoute
  '/drive/starred': typeof AuthenticatedDriveStarredRoute
  '/drive/storage': typeof AuthenticatedDriveStorageRoute
  '/drive/trash': typeof AuthenticatedDriveTrashRoute
  '/forms/new': typeof AuthenticatedFormsNewRoute
  '/forms/templates': typeof AuthenticatedFormsTemplatesRoute
  '/formsv2/new': typeof AuthenticatedFormsv2NewRoute
  '/formsv2/templates': typeof AuthenticatedFormsv2TemplatesRoute
  '/sheets/$spreadsheetId': typeof AuthenticatedSheetsSpreadsheetIdRoute
  '/sheets/new': typeof AuthenticatedSheetsNewRoute
  '/sheets/templates': typeof AuthenticatedSheetsTemplatesRoute
  '/forms/$formId/fill': typeof FormsFormIdFillRoute
  '/formsv2/f/$formId': typeof Formsv2FFormIdRoute
  '/formsv3/f/$formId': typeof Formsv3FFormIdRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/docs': typeof AuthenticatedDocsIndexRoute
  '/drive': typeof AuthenticatedDriveIndexRoute
  '/forms': typeof AuthenticatedFormsIndexRoute
  '/formsv2': typeof AuthenticatedFormsv2IndexRoute
  '/formsv3': typeof AuthenticatedFormsv3IndexRoute
  '/sheets': typeof AuthenticatedSheetsIndexRoute
  '/drive/file/$fileId': typeof AuthenticatedDriveFileFileIdRoute
  '/drive/folder/$folderId': typeof AuthenticatedDriveFolderFolderIdRoute
  '/forms/$formId/edit': typeof AuthenticatedFormsFormIdEditRoute
  '/forms/$formId/preview': typeof AuthenticatedFormsFormIdPreviewRoute
  '/forms/$formId/responses': typeof AuthenticatedFormsFormIdResponsesRoute
  '/formsv2/$formId/content': typeof AuthenticatedFormsv2FormIdContentRoute
  '/formsv2/$formId/design': typeof AuthenticatedFormsv2FormIdDesignRoute
  '/formsv2/$formId/results': typeof AuthenticatedFormsv2FormIdResultsRoute
  '/formsv2/$formId/share': typeof AuthenticatedFormsv2FormIdShareRoute
  '/formsv2/$formId/workflow': typeof AuthenticatedFormsv2FormIdWorkflowRoute
  '/formsv2/$formId/preview': typeof AuthenticatedFormsv2FormIdPreviewRoute
  '/formsv3/$formId/submissions': typeof AuthenticatedFormsv3FormIdSubmissionsRoute
  '/forms/$formId': typeof AuthenticatedFormsFormIdIndexRoute
  '/formsv2/$formId': typeof AuthenticatedFormsv2FormIdIndexRoute
  '/formsv3/$formId': typeof AuthenticatedFormsv3FormIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/_authenticated/drive': typeof AuthenticatedDriveRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/share/$token': typeof ShareTokenRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/admin/audit': typeof AuthenticatedAdminAuditRoute
  '/_authenticated/admin/content': typeof AuthenticatedAdminContentRoute
  '/_authenticated/admin/email': typeof AuthenticatedAdminEmailRoute
  '/_authenticated/admin/policies': typeof AuthenticatedAdminPoliciesRoute
  '/_authenticated/admin/security': typeof AuthenticatedAdminSecurityRoute
  '/_authenticated/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/_authenticated/admin/storage': typeof AuthenticatedAdminStorageRoute
  '/_authenticated/admin/users': typeof AuthenticatedAdminUsersRoute
  '/_authenticated/docs/$documentId': typeof AuthenticatedDocsDocumentIdRoute
  '/_authenticated/docs/new': typeof AuthenticatedDocsNewRoute
  '/_authenticated/docs/templates': typeof AuthenticatedDocsTemplatesRoute
  '/_authenticated/drive/recent': typeof AuthenticatedDriveRecentRoute
  '/_authenticated/drive/search': typeof AuthenticatedDriveSearchRoute
  '/_authenticated/drive/shared': typeof AuthenticatedDriveSharedRoute
  '/_authenticated/drive/spam': typeof AuthenticatedDriveSpamRoute
  '/_authenticated/drive/starred': typeof AuthenticatedDriveStarredRoute
  '/_authenticated/drive/storage': typeof AuthenticatedDriveStorageRoute
  '/_authenticated/drive/trash': typeof AuthenticatedDriveTrashRoute
  '/_authenticated/forms/new': typeof AuthenticatedFormsNewRoute
  '/_authenticated/forms/templates': typeof AuthenticatedFormsTemplatesRoute
  '/_authenticated/formsv2/$formId': typeof AuthenticatedFormsv2FormIdRouteWithChildren
  '/_authenticated/formsv2/new': typeof AuthenticatedFormsv2NewRoute
  '/_authenticated/formsv2/templates': typeof AuthenticatedFormsv2TemplatesRoute
  '/_authenticated/sheets/$spreadsheetId': typeof AuthenticatedSheetsSpreadsheetIdRoute
  '/_authenticated/sheets/new': typeof AuthenticatedSheetsNewRoute
  '/_authenticated/sheets/templates': typeof AuthenticatedSheetsTemplatesRoute
  '/forms/$formId/fill': typeof FormsFormIdFillRoute
  '/formsv2/f/$formId': typeof Formsv2FFormIdRoute
  '/formsv3/f/$formId': typeof Formsv3FFormIdRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/docs/': typeof AuthenticatedDocsIndexRoute
  '/_authenticated/drive/': typeof AuthenticatedDriveIndexRoute
  '/_authenticated/forms/': typeof AuthenticatedFormsIndexRoute
  '/_authenticated/formsv2/': typeof AuthenticatedFormsv2IndexRoute
  '/_authenticated/formsv3/': typeof AuthenticatedFormsv3IndexRoute
  '/_authenticated/sheets/': typeof AuthenticatedSheetsIndexRoute
  '/_authenticated/drive/file/$fileId': typeof AuthenticatedDriveFileFileIdRoute
  '/_authenticated/drive/folder/$folderId': typeof AuthenticatedDriveFolderFolderIdRoute
  '/_authenticated/forms/$formId/edit': typeof AuthenticatedFormsFormIdEditRoute
  '/_authenticated/forms/$formId/preview': typeof AuthenticatedFormsFormIdPreviewRoute
  '/_authenticated/forms/$formId/responses': typeof AuthenticatedFormsFormIdResponsesRoute
  '/_authenticated/formsv2/$formId/content': typeof AuthenticatedFormsv2FormIdContentRoute
  '/_authenticated/formsv2/$formId/design': typeof AuthenticatedFormsv2FormIdDesignRoute
  '/_authenticated/formsv2/$formId/results': typeof AuthenticatedFormsv2FormIdResultsRoute
  '/_authenticated/formsv2/$formId/share': typeof AuthenticatedFormsv2FormIdShareRoute
  '/_authenticated/formsv2/$formId/workflow': typeof AuthenticatedFormsv2FormIdWorkflowRoute
  '/_authenticated/formsv2/$formId_/preview': typeof AuthenticatedFormsv2FormIdPreviewRoute
  '/_authenticated/formsv3/$formId/submissions': typeof AuthenticatedFormsv3FormIdSubmissionsRoute
  '/_authenticated/forms/$formId/': typeof AuthenticatedFormsFormIdIndexRoute
  '/_authenticated/formsv2/$formId/': typeof AuthenticatedFormsv2FormIdIndexRoute
  '/_authenticated/formsv3/$formId/': typeof AuthenticatedFormsv3FormIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/admin'
    | '/drive'
    | '/settings'
    | '/invite/$token'
    | '/share/$token'
    | '/admin/audit'
    | '/admin/content'
    | '/admin/email'
    | '/admin/policies'
    | '/admin/security'
    | '/admin/settings'
    | '/admin/storage'
    | '/admin/users'
    | '/docs/$documentId'
    | '/docs/new'
    | '/docs/templates'
    | '/drive/recent'
    | '/drive/search'
    | '/drive/shared'
    | '/drive/spam'
    | '/drive/starred'
    | '/drive/storage'
    | '/drive/trash'
    | '/forms/new'
    | '/forms/templates'
    | '/formsv2/$formId'
    | '/formsv2/new'
    | '/formsv2/templates'
    | '/sheets/$spreadsheetId'
    | '/sheets/new'
    | '/sheets/templates'
    | '/forms/$formId/fill'
    | '/formsv2/f/$formId'
    | '/formsv3/f/$formId'
    | '/admin/'
    | '/docs/'
    | '/drive/'
    | '/forms/'
    | '/formsv2/'
    | '/formsv3/'
    | '/sheets/'
    | '/drive/file/$fileId'
    | '/drive/folder/$folderId'
    | '/forms/$formId/edit'
    | '/forms/$formId/preview'
    | '/forms/$formId/responses'
    | '/formsv2/$formId/content'
    | '/formsv2/$formId/design'
    | '/formsv2/$formId/results'
    | '/formsv2/$formId/share'
    | '/formsv2/$formId/workflow'
    | '/formsv2/$formId/preview'
    | '/formsv3/$formId/submissions'
    | '/forms/$formId/'
    | '/formsv2/$formId/'
    | '/formsv3/$formId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/settings'
    | '/invite/$token'
    | '/share/$token'
    | '/'
    | '/admin/audit'
    | '/admin/content'
    | '/admin/email'
    | '/admin/policies'
    | '/admin/security'
    | '/admin/settings'
    | '/admin/storage'
    | '/admin/users'
    | '/docs/$documentId'
    | '/docs/new'
    | '/docs/templates'
    | '/drive/recent'
    | '/drive/search'
    | '/drive/shared'
    | '/drive/spam'
    | '/drive/starred'
    | '/drive/storage'
    | '/drive/trash'
    | '/forms/new'
    | '/forms/templates'
    | '/formsv2/new'
    | '/formsv2/templates'
    | '/sheets/$spreadsheetId'
    | '/sheets/new'
    | '/sheets/templates'
    | '/forms/$formId/fill'
    | '/formsv2/f/$formId'
    | '/formsv3/f/$formId'
    | '/admin'
    | '/docs'
    | '/drive'
    | '/forms'
    | '/formsv2'
    | '/formsv3'
    | '/sheets'
    | '/drive/file/$fileId'
    | '/drive/folder/$folderId'
    | '/forms/$formId/edit'
    | '/forms/$formId/preview'
    | '/forms/$formId/responses'
    | '/formsv2/$formId/content'
    | '/formsv2/$formId/design'
    | '/formsv2/$formId/results'
    | '/formsv2/$formId/share'
    | '/formsv2/$formId/workflow'
    | '/formsv2/$formId/preview'
    | '/formsv3/$formId/submissions'
    | '/forms/$formId'
    | '/formsv2/$formId'
    | '/formsv3/$formId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/_authenticated/admin'
    | '/_authenticated/drive'
    | '/_authenticated/settings'
    | '/invite/$token'
    | '/share/$token'
    | '/_authenticated/'
    | '/_authenticated/admin/audit'
    | '/_authenticated/admin/content'
    | '/_authenticated/admin/email'
    | '/_authenticated/admin/policies'
    | '/_authenticated/admin/security'
    | '/_authenticated/admin/settings'
    | '/_authenticated/admin/storage'
    | '/_authenticated/admin/users'
    | '/_authenticated/docs/$documentId'
    | '/_authenticated/docs/new'
    | '/_authenticated/docs/templates'
    | '/_authenticated/drive/recent'
    | '/_authenticated/drive/search'
    | '/_authenticated/drive/shared'
    | '/_authenticated/drive/spam'
    | '/_authenticated/drive/starred'
    | '/_authenticated/drive/storage'
    | '/_authenticated/drive/trash'
    | '/_authenticated/forms/new'
    | '/_authenticated/forms/templates'
    | '/_authenticated/formsv2/$formId'
    | '/_authenticated/formsv2/new'
    | '/_authenticated/formsv2/templates'
    | '/_authenticated/sheets/$spreadsheetId'
    | '/_authenticated/sheets/new'
    | '/_authenticated/sheets/templates'
    | '/forms/$formId/fill'
    | '/formsv2/f/$formId'
    | '/formsv3/f/$formId'
    | '/_authenticated/admin/'
    | '/_authenticated/docs/'
    | '/_authenticated/drive/'
    | '/_authenticated/forms/'
    | '/_authenticated/formsv2/'
    | '/_authenticated/formsv3/'
    | '/_authenticated/sheets/'
    | '/_authenticated/drive/file/$fileId'
    | '/_authenticated/drive/folder/$folderId'
    | '/_authenticated/forms/$formId/edit'
    | '/_authenticated/forms/$formId/preview'
    | '/_authenticated/forms/$formId/responses'
    | '/_authenticated/formsv2/$formId/content'
    | '/_authenticated/formsv2/$formId/design'
    | '/_authenticated/formsv2/$formId/results'
    | '/_authenticated/formsv2/$formId/share'
    | '/_authenticated/formsv2/$formId/workflow'
    | '/_authenticated/formsv2/$formId_/preview'
    | '/_authenticated/formsv3/$formId/submissions'
    | '/_authenticated/forms/$formId/'
    | '/_authenticated/formsv2/$formId/'
    | '/_authenticated/formsv3/$formId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  InviteTokenRoute: typeof InviteTokenRoute
  ShareTokenRoute: typeof ShareTokenRoute
  FormsFormIdFillRoute: typeof FormsFormIdFillRoute
  Formsv2FFormIdRoute: typeof Formsv2FFormIdRoute
  Formsv3FFormIdRoute: typeof Formsv3FFormIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/drive': {
      id: '/_authenticated/drive'
      path: '/drive'
      fullPath: '/drive'
      preLoaderRoute: typeof AuthenticatedDriveRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/audit': {
      id: '/_authenticated/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AuthenticatedAdminAuditRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/content': {
      id: '/_authenticated/admin/content'
      path: '/content'
      fullPath: '/admin/content'
      preLoaderRoute: typeof AuthenticatedAdminContentRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/email': {
      id: '/_authenticated/admin/email'
      path: '/email'
      fullPath: '/admin/email'
      preLoaderRoute: typeof AuthenticatedAdminEmailRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/policies': {
      id: '/_authenticated/admin/policies'
      path: '/policies'
      fullPath: '/admin/policies'
      preLoaderRoute: typeof AuthenticatedAdminPoliciesRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/security': {
      id: '/_authenticated/admin/security'
      path: '/security'
      fullPath: '/admin/security'
      preLoaderRoute: typeof AuthenticatedAdminSecurityRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/settings': {
      id: '/_authenticated/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthenticatedAdminSettingsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/storage': {
      id: '/_authenticated/admin/storage'
      path: '/storage'
      fullPath: '/admin/storage'
      preLoaderRoute: typeof AuthenticatedAdminStorageRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/users': {
      id: '/_authenticated/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/docs/': {
      id: '/_authenticated/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof AuthenticatedDocsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/docs/$documentId': {
      id: '/_authenticated/docs/$documentId'
      path: '/docs/$documentId'
      fullPath: '/docs/$documentId'
      preLoaderRoute: typeof AuthenticatedDocsDocumentIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/docs/new': {
      id: '/_authenticated/docs/new'
      path: '/docs/new'
      fullPath: '/docs/new'
      preLoaderRoute: typeof AuthenticatedDocsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/docs/templates': {
      id: '/_authenticated/docs/templates'
      path: '/docs/templates'
      fullPath: '/docs/templates'
      preLoaderRoute: typeof AuthenticatedDocsTemplatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/drive/': {
      id: '/_authenticated/drive/'
      path: '/'
      fullPath: '/drive/'
      preLoaderRoute: typeof AuthenticatedDriveIndexRouteImport
      parentRoute: typeof AuthenticatedDriveRouteRoute
    }
    '/_authenticated/drive/recent': {
      id: '/_authenticated/drive/recent'
      path: '/recent'
      fullPath: '/drive/recent'
      preLoaderRoute: typeof AuthenticatedDriveRecentRouteImport
      parentRoute: typeof AuthenticatedDriveRouteRoute
    }
    '/_authenticated/drive/search': {
      id: '/_authenticated/drive/search'
      path: '/search'
      fullPath: '/drive/search'
      preLoaderRoute: typeof AuthenticatedDriveSearchRouteImport
      parentRoute: typeof AuthenticatedDriveRouteRoute
    }
    '/_authenticated/drive/shared': {
      id: '/_authenticated/drive/shared'
      path: '/shared'
      fullPath: '/drive/shared'
      preLoaderRoute: typeof AuthenticatedDriveSharedRouteImport
      parentRoute: typeof AuthenticatedDriveRouteRoute
    }
    '/_authenticated/drive/spam': {
      id: '/_authenticated/drive/spam'
      path: '/spam'
      fullPath: '/drive/spam'
      preLoaderRoute: typeof AuthenticatedDriveSpamRouteImport
      parentRoute: typeof AuthenticatedDriveRouteRoute
    }
    '/_authenticated/drive/starred': {
      id: '/_authenticated/drive/starred'
      path: '/starred'
      fullPath: '/drive/starred'
      preLoaderRoute: typeof AuthenticatedDriveStarredRouteImport
      parentRoute: typeof AuthenticatedDriveRouteRoute
    }
    '/_authenticated/drive/storage': {
      id: '/_authenticated/drive/storage'
      path: '/storage'
      fullPath: '/drive/storage'
      preLoaderRoute: typeof AuthenticatedDriveStorageRouteImport
      parentRoute: typeof AuthenticatedDriveRouteRoute
    }
    '/_authenticated/drive/trash': {
      id: '/_authenticated/drive/trash'
      path: '/trash'
      fullPath: '/drive/trash'
      preLoaderRoute: typeof AuthenticatedDriveTrashRouteImport
      parentRoute: typeof AuthenticatedDriveRouteRoute
    }
    '/_authenticated/forms/': {
      id: '/_authenticated/forms/'
      path: '/forms'
      fullPath: '/forms/'
      preLoaderRoute: typeof AuthenticatedFormsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/forms/new': {
      id: '/_authenticated/forms/new'
      path: '/forms/new'
      fullPath: '/forms/new'
      preLoaderRoute: typeof AuthenticatedFormsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/forms/templates': {
      id: '/_authenticated/forms/templates'
      path: '/forms/templates'
      fullPath: '/forms/templates'
      preLoaderRoute: typeof AuthenticatedFormsTemplatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/formsv2/': {
      id: '/_authenticated/formsv2/'
      path: '/formsv2'
      fullPath: '/formsv2/'
      preLoaderRoute: typeof AuthenticatedFormsv2IndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/formsv2/$formId': {
      id: '/_authenticated/formsv2/$formId'
      path: '/formsv2/$formId'
      fullPath: '/formsv2/$formId'
      preLoaderRoute: typeof AuthenticatedFormsv2FormIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/formsv2/new': {
      id: '/_authenticated/formsv2/new'
      path: '/formsv2/new'
      fullPath: '/formsv2/new'
      preLoaderRoute: typeof AuthenticatedFormsv2NewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/formsv2/templates': {
      id: '/_authenticated/formsv2/templates'
      path: '/formsv2/templates'
      fullPath: '/formsv2/templates'
      preLoaderRoute: typeof AuthenticatedFormsv2TemplatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/formsv3/': {
      id: '/_authenticated/formsv3/'
      path: '/formsv3'
      fullPath: '/formsv3/'
      preLoaderRoute: typeof AuthenticatedFormsv3IndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sheets/': {
      id: '/_authenticated/sheets/'
      path: '/sheets'
      fullPath: '/sheets/'
      preLoaderRoute: typeof AuthenticatedSheetsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sheets/$spreadsheetId': {
      id: '/_authenticated/sheets/$spreadsheetId'
      path: '/sheets/$spreadsheetId'
      fullPath: '/sheets/$spreadsheetId'
      preLoaderRoute: typeof AuthenticatedSheetsSpreadsheetIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sheets/new': {
      id: '/_authenticated/sheets/new'
      path: '/sheets/new'
      fullPath: '/sheets/new'
      preLoaderRoute: typeof AuthenticatedSheetsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/sheets/templates': {
      id: '/_authenticated/sheets/templates'
      path: '/sheets/templates'
      fullPath: '/sheets/templates'
      preLoaderRoute: typeof AuthenticatedSheetsTemplatesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/forms/$formId/fill': {
      id: '/forms/$formId/fill'
      path: '/forms/$formId/fill'
      fullPath: '/forms/$formId/fill'
      preLoaderRoute: typeof FormsFormIdFillRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/formsv2/f/$formId': {
      id: '/formsv2/f/$formId'
      path: '/formsv2/f/$formId'
      fullPath: '/formsv2/f/$formId'
      preLoaderRoute: typeof Formsv2FFormIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/formsv3/f/$formId': {
      id: '/formsv3/f/$formId'
      path: '/formsv3/f/$formId'
      fullPath: '/formsv3/f/$formId'
      preLoaderRoute: typeof Formsv3FFormIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/drive/file/$fileId': {
      id: '/_authenticated/drive/file/$fileId'
      path: '/file/$fileId'
      fullPath: '/drive/file/$fileId'
      preLoaderRoute: typeof AuthenticatedDriveFileFileIdRouteImport
      parentRoute: typeof AuthenticatedDriveRouteRoute
    }
    '/_authenticated/drive/folder/$folderId': {
      id: '/_authenticated/drive/folder/$folderId'
      path: '/folder/$folderId'
      fullPath: '/drive/folder/$folderId'
      preLoaderRoute: typeof AuthenticatedDriveFolderFolderIdRouteImport
      parentRoute: typeof AuthenticatedDriveRouteRoute
    }
    '/_authenticated/forms/$formId/': {
      id: '/_authenticated/forms/$formId/'
      path: '/forms/$formId'
      fullPath: '/forms/$formId/'
      preLoaderRoute: typeof AuthenticatedFormsFormIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/forms/$formId/edit': {
      id: '/_authenticated/forms/$formId/edit'
      path: '/forms/$formId/edit'
      fullPath: '/forms/$formId/edit'
      preLoaderRoute: typeof AuthenticatedFormsFormIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/forms/$formId/preview': {
      id: '/_authenticated/forms/$formId/preview'
      path: '/forms/$formId/preview'
      fullPath: '/forms/$formId/preview'
      preLoaderRoute: typeof AuthenticatedFormsFormIdPreviewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/forms/$formId/responses': {
      id: '/_authenticated/forms/$formId/responses'
      path: '/forms/$formId/responses'
      fullPath: '/forms/$formId/responses'
      preLoaderRoute: typeof AuthenticatedFormsFormIdResponsesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/formsv2/$formId/': {
      id: '/_authenticated/formsv2/$formId/'
      path: '/'
      fullPath: '/formsv2/$formId/'
      preLoaderRoute: typeof AuthenticatedFormsv2FormIdIndexRouteImport
      parentRoute: typeof AuthenticatedFormsv2FormIdRoute
    }
    '/_authenticated/formsv2/$formId/content': {
      id: '/_authenticated/formsv2/$formId/content'
      path: '/content'
      fullPath: '/formsv2/$formId/content'
      preLoaderRoute: typeof AuthenticatedFormsv2FormIdContentRouteImport
      parentRoute: typeof AuthenticatedFormsv2FormIdRoute
    }
    '/_authenticated/formsv2/$formId/design': {
      id: '/_authenticated/formsv2/$formId/design'
      path: '/design'
      fullPath: '/formsv2/$formId/design'
      preLoaderRoute: typeof AuthenticatedFormsv2FormIdDesignRouteImport
      parentRoute: typeof AuthenticatedFormsv2FormIdRoute
    }
    '/_authenticated/formsv2/$formId/results': {
      id: '/_authenticated/formsv2/$formId/results'
      path: '/results'
      fullPath: '/formsv2/$formId/results'
      preLoaderRoute: typeof AuthenticatedFormsv2FormIdResultsRouteImport
      parentRoute: typeof AuthenticatedFormsv2FormIdRoute
    }
    '/_authenticated/formsv2/$formId/share': {
      id: '/_authenticated/formsv2/$formId/share'
      path: '/share'
      fullPath: '/formsv2/$formId/share'
      preLoaderRoute: typeof AuthenticatedFormsv2FormIdShareRouteImport
      parentRoute: typeof AuthenticatedFormsv2FormIdRoute
    }
    '/_authenticated/formsv2/$formId/workflow': {
      id: '/_authenticated/formsv2/$formId/workflow'
      path: '/workflow'
      fullPath: '/formsv2/$formId/workflow'
      preLoaderRoute: typeof AuthenticatedFormsv2FormIdWorkflowRouteImport
      parentRoute: typeof AuthenticatedFormsv2FormIdRoute
    }
    '/_authenticated/formsv2/$formId_/preview': {
      id: '/_authenticated/formsv2/$formId_/preview'
      path: '/formsv2/$formId/preview'
      fullPath: '/formsv2/$formId/preview'
      preLoaderRoute: typeof AuthenticatedFormsv2FormIdPreviewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/formsv3/$formId/': {
      id: '/_authenticated/formsv3/$formId/'
      path: '/formsv3/$formId'
      fullPath: '/formsv3/$formId/'
      preLoaderRoute: typeof AuthenticatedFormsv3FormIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/formsv3/$formId/submissions': {
      id: '/_authenticated/formsv3/$formId/submissions'
      path: '/formsv3/$formId/submissions'
      fullPath: '/formsv3/$formId/submissions'
      preLoaderRoute: typeof AuthenticatedFormsv3FormIdSubmissionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminAuditRoute: typeof AuthenticatedAdminAuditRoute
  AuthenticatedAdminContentRoute: typeof AuthenticatedAdminContentRoute
  AuthenticatedAdminEmailRoute: typeof AuthenticatedAdminEmailRoute
  AuthenticatedAdminPoliciesRoute: typeof AuthenticatedAdminPoliciesRoute
  AuthenticatedAdminSecurityRoute: typeof AuthenticatedAdminSecurityRoute
  AuthenticatedAdminSettingsRoute: typeof AuthenticatedAdminSettingsRoute
  AuthenticatedAdminStorageRoute: typeof AuthenticatedAdminStorageRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,
    AuthenticatedAdminContentRoute: AuthenticatedAdminContentRoute,
    AuthenticatedAdminEmailRoute: AuthenticatedAdminEmailRoute,
    AuthenticatedAdminPoliciesRoute: AuthenticatedAdminPoliciesRoute,
    AuthenticatedAdminSecurityRoute: AuthenticatedAdminSecurityRoute,
    AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,
    AuthenticatedAdminStorageRoute: AuthenticatedAdminStorageRoute,
    AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
    AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedDriveRouteRouteChildren {
  AuthenticatedDriveRecentRoute: typeof AuthenticatedDriveRecentRoute
  AuthenticatedDriveSearchRoute: typeof AuthenticatedDriveSearchRoute
  AuthenticatedDriveSharedRoute: typeof AuthenticatedDriveSharedRoute
  AuthenticatedDriveSpamRoute: typeof AuthenticatedDriveSpamRoute
  AuthenticatedDriveStarredRoute: typeof AuthenticatedDriveStarredRoute
  AuthenticatedDriveStorageRoute: typeof AuthenticatedDriveStorageRoute
  AuthenticatedDriveTrashRoute: typeof AuthenticatedDriveTrashRoute
  AuthenticatedDriveIndexRoute: typeof AuthenticatedDriveIndexRoute
  AuthenticatedDriveFileFileIdRoute: typeof AuthenticatedDriveFileFileIdRoute
  AuthenticatedDriveFolderFolderIdRoute: typeof AuthenticatedDriveFolderFolderIdRoute
}

const AuthenticatedDriveRouteRouteChildren: AuthenticatedDriveRouteRouteChildren =
  {
    AuthenticatedDriveRecentRoute: AuthenticatedDriveRecentRoute,
    AuthenticatedDriveSearchRoute: AuthenticatedDriveSearchRoute,
    AuthenticatedDriveSharedRoute: AuthenticatedDriveSharedRoute,
    AuthenticatedDriveSpamRoute: AuthenticatedDriveSpamRoute,
    AuthenticatedDriveStarredRoute: AuthenticatedDriveStarredRoute,
    AuthenticatedDriveStorageRoute: AuthenticatedDriveStorageRoute,
    AuthenticatedDriveTrashRoute: AuthenticatedDriveTrashRoute,
    AuthenticatedDriveIndexRoute: AuthenticatedDriveIndexRoute,
    AuthenticatedDriveFileFileIdRoute: AuthenticatedDriveFileFileIdRoute,
    AuthenticatedDriveFolderFolderIdRoute:
      AuthenticatedDriveFolderFolderIdRoute,
  }

const AuthenticatedDriveRouteRouteWithChildren =
  AuthenticatedDriveRouteRoute._addFileChildren(
    AuthenticatedDriveRouteRouteChildren,
  )

interface AuthenticatedFormsv2FormIdRouteChildren {
  AuthenticatedFormsv2FormIdContentRoute: typeof AuthenticatedFormsv2FormIdContentRoute
  AuthenticatedFormsv2FormIdDesignRoute: typeof AuthenticatedFormsv2FormIdDesignRoute
  AuthenticatedFormsv2FormIdResultsRoute: typeof AuthenticatedFormsv2FormIdResultsRoute
  AuthenticatedFormsv2FormIdShareRoute: typeof AuthenticatedFormsv2FormIdShareRoute
  AuthenticatedFormsv2FormIdWorkflowRoute: typeof AuthenticatedFormsv2FormIdWorkflowRoute
  AuthenticatedFormsv2FormIdIndexRoute: typeof AuthenticatedFormsv2FormIdIndexRoute
}

const AuthenticatedFormsv2FormIdRouteChildren: AuthenticatedFormsv2FormIdRouteChildren =
  {
    AuthenticatedFormsv2FormIdContentRoute:
      AuthenticatedFormsv2FormIdContentRoute,
    AuthenticatedFormsv2FormIdDesignRoute:
      AuthenticatedFormsv2FormIdDesignRoute,
    AuthenticatedFormsv2FormIdResultsRoute:
      AuthenticatedFormsv2FormIdResultsRoute,
    AuthenticatedFormsv2FormIdShareRoute: AuthenticatedFormsv2FormIdShareRoute,
    AuthenticatedFormsv2FormIdWorkflowRoute:
      AuthenticatedFormsv2FormIdWorkflowRoute,
    AuthenticatedFormsv2FormIdIndexRoute: AuthenticatedFormsv2FormIdIndexRoute,
  }

const AuthenticatedFormsv2FormIdRouteWithChildren =
  AuthenticatedFormsv2FormIdRoute._addFileChildren(
    AuthenticatedFormsv2FormIdRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
  AuthenticatedDriveRouteRoute: typeof AuthenticatedDriveRouteRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedDocsDocumentIdRoute: typeof AuthenticatedDocsDocumentIdRoute
  AuthenticatedDocsNewRoute: typeof AuthenticatedDocsNewRoute
  AuthenticatedDocsTemplatesRoute: typeof AuthenticatedDocsTemplatesRoute
  AuthenticatedFormsNewRoute: typeof AuthenticatedFormsNewRoute
  AuthenticatedFormsTemplatesRoute: typeof AuthenticatedFormsTemplatesRoute
  AuthenticatedFormsv2FormIdRoute: typeof AuthenticatedFormsv2FormIdRouteWithChildren
  AuthenticatedFormsv2NewRoute: typeof AuthenticatedFormsv2NewRoute
  AuthenticatedFormsv2TemplatesRoute: typeof AuthenticatedFormsv2TemplatesRoute
  AuthenticatedSheetsSpreadsheetIdRoute: typeof AuthenticatedSheetsSpreadsheetIdRoute
  AuthenticatedSheetsNewRoute: typeof AuthenticatedSheetsNewRoute
  AuthenticatedSheetsTemplatesRoute: typeof AuthenticatedSheetsTemplatesRoute
  AuthenticatedDocsIndexRoute: typeof AuthenticatedDocsIndexRoute
  AuthenticatedFormsIndexRoute: typeof AuthenticatedFormsIndexRoute
  AuthenticatedFormsv2IndexRoute: typeof AuthenticatedFormsv2IndexRoute
  AuthenticatedFormsv3IndexRoute: typeof AuthenticatedFormsv3IndexRoute
  AuthenticatedSheetsIndexRoute: typeof AuthenticatedSheetsIndexRoute
  AuthenticatedFormsFormIdEditRoute: typeof AuthenticatedFormsFormIdEditRoute
  AuthenticatedFormsFormIdPreviewRoute: typeof AuthenticatedFormsFormIdPreviewRoute
  AuthenticatedFormsFormIdResponsesRoute: typeof AuthenticatedFormsFormIdResponsesRoute
  AuthenticatedFormsv2FormIdPreviewRoute: typeof AuthenticatedFormsv2FormIdPreviewRoute
  AuthenticatedFormsv3FormIdSubmissionsRoute: typeof AuthenticatedFormsv3FormIdSubmissionsRoute
  AuthenticatedFormsFormIdIndexRoute: typeof AuthenticatedFormsFormIdIndexRoute
  AuthenticatedFormsv3FormIdIndexRoute: typeof AuthenticatedFormsv3FormIdIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedDriveRouteRoute: AuthenticatedDriveRouteRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedDocsDocumentIdRoute: AuthenticatedDocsDocumentIdRoute,
  AuthenticatedDocsNewRoute: AuthenticatedDocsNewRoute,
  AuthenticatedDocsTemplatesRoute: AuthenticatedDocsTemplatesRoute,
  AuthenticatedFormsNewRoute: AuthenticatedFormsNewRoute,
  AuthenticatedFormsTemplatesRoute: AuthenticatedFormsTemplatesRoute,
  AuthenticatedFormsv2FormIdRoute: AuthenticatedFormsv2FormIdRouteWithChildren,
  AuthenticatedFormsv2NewRoute: AuthenticatedFormsv2NewRoute,
  AuthenticatedFormsv2TemplatesRoute: AuthenticatedFormsv2TemplatesRoute,
  AuthenticatedSheetsSpreadsheetIdRoute: AuthenticatedSheetsSpreadsheetIdRoute,
  AuthenticatedSheetsNewRoute: AuthenticatedSheetsNewRoute,
  AuthenticatedSheetsTemplatesRoute: AuthenticatedSheetsTemplatesRoute,
  AuthenticatedDocsIndexRoute: AuthenticatedDocsIndexRoute,
  AuthenticatedFormsIndexRoute: AuthenticatedFormsIndexRoute,
  AuthenticatedFormsv2IndexRoute: AuthenticatedFormsv2IndexRoute,
  AuthenticatedFormsv3IndexRoute: AuthenticatedFormsv3IndexRoute,
  AuthenticatedSheetsIndexRoute: AuthenticatedSheetsIndexRoute,
  AuthenticatedFormsFormIdEditRoute: AuthenticatedFormsFormIdEditRoute,
  AuthenticatedFormsFormIdPreviewRoute: AuthenticatedFormsFormIdPreviewRoute,
  AuthenticatedFormsFormIdResponsesRoute:
    AuthenticatedFormsFormIdResponsesRoute,
  AuthenticatedFormsv2FormIdPreviewRoute:
    AuthenticatedFormsv2FormIdPreviewRoute,
  AuthenticatedFormsv3FormIdSubmissionsRoute:
    AuthenticatedFormsv3FormIdSubmissionsRoute,
  AuthenticatedFormsFormIdIndexRoute: AuthenticatedFormsFormIdIndexRoute,
  AuthenticatedFormsv3FormIdIndexRoute: AuthenticatedFormsv3FormIdIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  InviteTokenRoute: InviteTokenRoute,
  ShareTokenRoute: ShareTokenRoute,
  FormsFormIdFillRoute: FormsFormIdFillRoute,
  Formsv2FFormIdRoute: Formsv2FFormIdRoute,
  Formsv3FFormIdRoute: Formsv3FFormIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
